<template>
  <div v-show="tldCanHavePrivacy">
    <!-- use pb-terms for the subscripton term length items 1 year, 2 years etc or for Plus zones -->
    <div v-show="show_add_privacy" class="pb-terms pb-grey-bck ps-4 pe-4 pt-3 pb-3">
      <div class="d-flex flex-row gap-2 justify-content-between mb-4">
        <div class="title pull-left pull-left pb-title">
          {{ $t('registration_privacy.private_registration') }}
          <span class="tip" data-placement="top" title="" data-bs-toggle="tooltip" :data-bs-title="privacyToolTip">
            <i class="fa fa-info-circle"></i>
          </span>
        </div>
        <div v-show="add_privacy == 'yes'" class="price text-end">${{ (9.95 * item.term).toFixed(2) }}</div>
      </div>
      <div class="form-group pull-left w-100 mb-5">
        <div class="col-sm-12 pl-0 d-flex flex-column gap-2">
          <!-- Private Reg Lst -->
          <div v-track="{ category: 'plan-builder', action: 'click', label: 'add-private-registration' }" class="form-check">
            <input v-model="add_privacy" :name="item.id" type="radio" class="form-check-input" value="yes" />
            <label class="form-check-label">
              <span class="lbl">
                {{ $t('registration_domain.hide_info') }}
                <span class="text-success">$9.95</span>
                {{ $t('common.yr') }}
              </span>
            </label>
          </div>
          <div v-track="{ category: 'plan-builder', action: 'click', label: 'no-thanks-private-registration' }" class="form-check">
            <input v-model="add_privacy" :name="item.id" type="radio" class="form-check-input" value="no" />
            <label class="form-check-label">
              <span class="lbl">{{ $t('registration_domain.no_thanks') }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div v-show="!show_add_privacy" class="pb-domain-term pull-left">
      <div class="title d-flex flex-row gap-2 mb-4">
        {{ $t('registration_domain.private_registration_no') }}
        <span class="tip" data-placement="top" title="" data-bs-toggle="tooltip" :data-bs-title="privacyToolTip">
          <i class="fa fa-info-circle text-noip-logo-grey"></i>
        </span>
        <a v-track="{ category: 'plan-builder', action: 'click', label: 'show-add-private-registration' }" class="text-info text-decoration-none" @click="show_add_privacy = true" role="button">{{ $t('common.edit') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'PrivacyUpsell',

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      add_privacy: 'yes',
      show_add_privacy: true,
      local_privacy_item: null
    };
  },

  created() {
    this.local_privacy_item = this.getPrivateRegAddOn(this.item.id);
    this.add_privacy = this.local_privacy_item ? 'yes' : 'no';
  },

  watch: {
    add_privacy(val) {
      if (val === 'yes' && this.tldCanHavePrivacy && this.local_privacy_item === null) {
        this.addPrivateReg();
      }

      if (val === 'no' && this.local_privacy_item !== null) {
        this.removePrivateReg();
        this.show_add_privacy = false;
      }
    }
  },

  computed: {
    ...mapState({
      addon_items: state => state.cart.addon_items
    }),
    privacyToolTip: function () {
      return this.$t('registration_privacy.tooltip');
    },
    tldCanHavePrivacy() {
      return this.$config('private_tlds').includes(this.item.options.tld);
    },
    privateRegAddOns() {
      return this.addon_items.filter(addon => {
        return addon.product_id == 'registration.privacy';
      });
    }
  },

  methods: {
    addPrivateReg() {
      if (!this.add_privacy === 'no') {
        return;
      }

      let product_data = {
        product_id: 'registration.privacy',
        term: this.item.term,
        options: {
          parent_id: this.item.id,
          domain: this.item.options.domain,
          tld: this.item.options.tld
        }
      };

      this.loading = true;

      this.addCartItem(product_data)
        .then(() => {
          this.local_privacy_item = this.getPrivateRegAddOn();
          this.loading = false;
        })
        .catch(() => {
          this.local_privacy_item = null;
          this.loading = false;
        });
    },

    removePrivateReg() {
      this.loading = true;

      this.removeAddOnItem({ id: this.local_privacy_item.id })
        .then(() => {
          this.local_privacy_item = null;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    getPrivateRegAddOn() {
      for (let addon of this.privateRegAddOns) {
        if (addon.parent_id === this.item.id) {
          return addon;
        }
      }

      return null;
    },

    ...mapActions('cart', ['removeAddOnItem', 'addCartItem'])
  }
};
</script>
